import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shouldRefresh: false
};

const forecastSlice = createSlice({
  name: 'forecast',
  initialState,
  reducers: {
    triggerForecastRefresh: (state) => {
      state.shouldRefresh = true;
    },
    resetForecastRefresh: (state) => {
      state.shouldRefresh = false;
    }
  }
});

export const forecastActions = forecastSlice.actions;

export default forecastSlice;